import React from "react";
import { usePage, Link } from "@inertiajs/react";
import BlogCardsItemOne from "@/Components/Cards/BlogCardsItemOne";
import CardsOne from "../../images/cards/cards-01.png";

const PostCard = React.forwardRef(({ blog }, ref) => {
    const { props: sharedProps } = usePage();
    const { buckets, tenantSlug } = sharedProps;
    const profileImagesBucket = buckets["profile_images"].name;
    const profileImagesRegion = buckets["profile_images"].region;
    const profileImageBaseUrl = `https://${profileImagesBucket}.s3.${profileImagesRegion}.amazonaws.com/${tenantSlug}/`;
    const currentUserIsOwner = blog?.user_id === sharedProps.auth?.user?.id;

    return (
        <div ref={ref}>
            <BlogCardsItemOne
                blogId={blog.id}
                blogUrl={blog.url_name}
                draft={blog.draft}
                currentUserIsOwner={currentUserIsOwner}
                images={blog.imageUrls}
                userName={blog.user.userName}
                userSrc={profileImageBaseUrl + blog.user.avatarImageFileName}
                name={`${blog.user.firstName} ${blog.user.lastName}`}
                date={new Date(blog.created_at).toLocaleDateString()}
                cardImageSrc={CardsOne}
                cardTitle={blog.title}
                cardContent={blog.preview_text}
            />
        </div>
    );
});

export default PostCard;
